import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'
import { TextLH } from 'styles/components/typography'

import { Wrapper, CheckIcon } from './styles'

const TextWithCheck = ({ text, bg, iconColor, ...props }) => {
  if (!text) {
    return null
  }

  return (
    <Wrapper {...props}>
      <CheckIcon bg={bg}>
        <Icon id="btn_check_xs" color={iconColor} />
      </CheckIcon>
      <TextLH
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
    </Wrapper>
  )
}

TextWithCheck.propTypes = {
  text: PropTypes.string,
  bg: PropTypes.string,
  iconColor: PropTypes.string,
}

TextWithCheck.defaultProps = {
  bg: 'grass',
  iconColor: 'white',
}

export default TextWithCheck
